import { Component } from "@angular/core";

@Component({
  selector: "app-unauthorize",
  template: ` <brd-unauthorize btnText="Refresh" (action)="reconnect()"></brd-unauthorize> `
})
export class UnauthorizeComponent {
  constructor() {}

  reconnect(): void {
    window.location.reload();
  }
}
